import * as React from 'react';
import { styled } from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import { stringToColor } from 'routes/BudgetModule/components/shared/InscriptionsGrid/InscriptionDetails/helpers/styleHelpers';
import { Notification } from 'components/Notifications/types';

type Props = {
    name: Notification['actorName'];
};

const StyAvatar = styled(Avatar, {
    name: 'StyAvatar',
})({
    width: '32px',
    height: '32px',
    fontSize: '15px',
});

/**
 * Display an avatar for notifications with the first letter of the name or a default icon
 */
const AvatarComponent = ({ name }: Props): JSX.Element => (
    <StyAvatar
        sx={{
            backgroundColor: stringToColor(name),
        }}
    >
        {name?.[0]?.toUpperCase()}
    </StyAvatar>
);

export default AvatarComponent;
